import {
  Flex,
  Badge,
  Center,
  Spinner,
  Alert,
  Button,
  FiExternalLink,
} from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { PLEDGE_SECTION_STATUSES_ICON } from '@bcba/frontend-utils';
import { Link } from 'react-router-dom';
import { paths } from '../../../../routes/paths';
import {
  COMPANY_TYPES,
  CROP_PLEDGE_USER_ROLES,
  PLEDGE_SECTION_STATUSES,
} from '@bcba/types';
import { PledgeCreditorFiscalIdSearchForm } from './PledgeCreditorFiscalIdSearchForm';
import {
  CropPledgeCreditorProvider,
  useCropPledgeCreditorContext,
} from './context/CropPledgeCreditorContext';
import { PledgeCreditorPFForm } from './PledgeCreditorPFForm';
import { PledgeCreditorPJForm } from './PledgeCreditorPJForm';
import { FormSection } from '../../shared';

const PledgeCreditorSection = () => {
  const { t } = useTranslation();

  const {
    isLoadingCreditorInformation,
    cropPledgeCreditorInformation,
    cropPledgeSectionsStatusBadgeColors,
    role,
    selectedCreditorData,
  } = useCropPledgeCreditorContext();

  if (isLoadingCreditorInformation || !cropPledgeCreditorInformation) {
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );
  }

  const { fiscalId } = cropPledgeCreditorInformation;
  const { companyType } = selectedCreditorData ?? {};
  const status =
    cropPledgeCreditorInformation.status ??
    PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD;

  return (
    <Flex flexDir={'column'}>
      <FormSection
        title={t('cropPledgeDetail.asideNav.creditorData')}
        badge={
          <Badge
            icon={PLEDGE_SECTION_STATUSES_ICON[status]}
            colorScheme={cropPledgeSectionsStatusBadgeColors[status]}
            mr="2"
            iconPosition="leading"
          >
            {t(`cropPledge.section.status.${status}`)}
          </Badge>
        }
        action={
          role === CROP_PLEDGE_USER_ROLES.CREDITOR ? (
            <Button
              alignSelf={'flex-end'}
              display={'flex'}
              as={Link}
              to={paths.home}
              variant="linkSecondary"
              lineHeight={'20px'}
              sx={{
                span: {
                  h: '16px',
                  w: '16px',
                  svg: {
                    h: '16px',
                    w: '16px',
                  },
                },
              }}
              leftIcon={<FiExternalLink />}
              size={'sm'}
            >
              {t('cropPledge.linkToDigitalDossier')}
            </Button>
          ) : null
        }
      >
        {role === CROP_PLEDGE_USER_ROLES.CREDITOR && (
          <Alert
            title={t('cropPledge.alert.title')}
            description={t('cropPledge.alert.detail')}
            variant="gray"
          />
        )}
        {!fiscalId && <PledgeCreditorFiscalIdSearchForm />}
        {selectedCreditorData && companyType && (
          <>
            {companyType === COMPANY_TYPES.PF ? (
              <PledgeCreditorPFForm />
            ) : (
              <PledgeCreditorPJForm />
            )}
          </>
        )}
      </FormSection>
    </Flex>
  );
};

const PledgeCreditorContextWrapper = () => {
  return (
    <CropPledgeCreditorProvider>
      <PledgeCreditorSection />
    </CropPledgeCreditorProvider>
  );
};

export default PledgeCreditorContextWrapper;
